import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.coffeeBrown,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 24
  const h = 25
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.97 2.516a.75.75 0 0 1 1.061 0l9 9a.75.75 0 0 1 0 1.062l-9 9a.751.751 0 0 1-1.062-1.062l8.47-8.47-8.47-8.468a.75.75 0 0 1 0-1.062Z"
        fill={color}
      />
    </svg>
  )
}

export default SvgComponent
